import { Card, Col, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { FilterOutlined } from "@ant-design/icons";
import LoadingSpin from "../../loadingSpin/LoadingSpin";
import DashboardService from "../../../services/DashboardService";

const CardView = ({ onDataAvailable, setGraphData }) => {
  const navigate = useNavigate();

  const [todaySummary, setTodaySummary] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getTodaySummary();
  }, []);

  const getTodaySummary = async () => {
    setIsLoading(true);

    try {
      const [outwardRes, dispatchRes, gsmRes] = await Promise.all([
        DashboardService.getTodayOutwardSummary(),
        DashboardService.getTodayDispatchQty(),
        DashboardService.getTodayGsmOutwardTotal(),
      ]);

      setTodaySummary({
        date: outwardRes?.date || dispatchRes?.date || gsmRes?.date || "-",
        cards: [
          {
            title: "Sewing Out",
            value: outwardRes?.total_pcs || 0,
            subValue: `${outwardRes?.total_kanban || 0} Kanban`,
            unit: "Pcs",
            path: "/active-kanban",
          },
          {
            title: "Dispatch Center",
            value: dispatchRes?.total_qty || 0,
            subValue: "Today Dispatch",
            unit: "Pcs",
            path: "/bin-status",
          },
          {
            title: "GSM Outward",
            value: gsmRes?.total_quantity || 0,
            subValue: "Today Outward",
            unit: "Pcs",
            path: "/daily-report",
          },
        ],
      });

      setGraphData?.({
        "Sewing Out": outwardRes?.total_pcs || 0,
        "Dispatch Center": dispatchRes?.total_qty || 0,
        "GSM Outward": gsmRes?.total_quantity || 0,
      });

      onDataAvailable?.(true);
    } catch (error) {
      console.error("Error fetching today summary:", error);
      onDataAvailable?.(false);
    } finally {
      setIsLoading(false);
    }
  };

  const getCardBgClass = (index) => {
    const classes = ["bg-card-green", "bg-card-orange", "bg-card-blue"];
    return classes[index % classes.length];
  };

  return (
    <div style={{ position: "relative" }}>
      <Card
        className="modern-card"
        style={{ marginBottom: 24 }}
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 12,
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <FilterOutlined />
              <Typography.Text strong>Area Summary</Typography.Text>
            </div>

            <Typography.Text type="secondary" style={{ fontWeight: 600 }}>
              Today: {todaySummary?.date || "-"}
            </Typography.Text>
          </div>
        }
      >
        {isLoading ? (
          <div className="dashboard-loading-wrap">
            <LoadingSpin />
          </div>
        ) : (
          <Row gutter={[16, 16]}>
            {todaySummary?.cards?.map((item, index) => (
              <Col xs={24} sm={12} md={8} key={item.title}>
                <div
                  className={`dashboard-stat-card ${getCardBgClass(index)}`}
                  onClick={() => navigate(item.path)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") navigate(item.path);
                  }}
                  style={{
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                >
                  <div className="dashboard-stat-card-inner">
                    <div>
                      <div
                        className="dashboard-stat-value"
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          gap: 6,
                        }}
                      >
                        <span>{item.value}</span>
                        <span
                          style={{
                            fontSize: 14,
                            fontWeight: 500,
                            opacity: 0.85,
                          }}
                        >
                          {item.unit}
                        </span>
                      </div>
                    </div>

                    <div>
                      <div className="dashboard-stat-title">{item.title}</div>
                      <div
                        style={{
                          color: "#08132e",
                          opacity: 0.9,
                          fontSize: 13,
                          marginTop: 4,
                        }}
                      >
                        {item.subValue}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        )}
      </Card>
    </div>
  );
};

export default CardView;